import baseService from "@/services/Base-service";

class PersonService {

  get controllerName() { return `/User/`; }
  get loginControllerName() { return '/Account/'; }


  getAll(searchModel) {
    return baseService.get(this.controllerName + 'PersonSearchManagement?' + baseService.getQueryStringOfObject(searchModel));
  }

  getAllMinInfo() {
    return baseService.get(this.controllerName + 'getallmin');
  }

  delete(Id) {
    return baseService.get(this.controllerName + 'delete?id=' + Id);
  }

  getDeleteUrl(itemId) {
    return this.controllerName + 'delete/' + itemId;
  }

  find(Id) {
    return baseService.get(this.controllerName + 'find/' + Id);
  }

  create(model) {
    return baseService.post(this.controllerName + 'create', model);
  }

  update(model) {
    return baseService.post(this.controllerName + 'update', model);
  }

  changePassword(model) {
    return baseService.post(this.controllerName + 'changePassword', model);
  }

  authentication(model) {
    return baseService.post(this.loginControllerName + 'login', model);
  }

  searchPerson(searchModel) {
    return baseService.get(this.controllerName + 'SearchPerson?' + baseService.getQueryStringOfObject(searchModel));
  }

  download_DoctorFile() {
    return baseService.getBaseUrl() + 'Download/Download_DoctorFile';
  }

  download_NotDoctorFile() {
    return baseService.getBaseUrl() + 'Download/Download_NotDoctorFile';
  }

  getListPersonHistory(personId, ItemCode) {
    return baseService.get('PersonHistoryManagement/GetList/' + personId + '/' + ItemCode);
  }

  selectLastPersonHistory(personId) {
    return baseService.get('PersonHistoryManagement/SelectLastPersonHistory/' + personId);
  }

  updatePersonParameters(personId, model) {
    return baseService.post('PersonHistoryManagement/UpdatePersonParameters', { PersonId: personId, model: model });
  }

  getCurrentUserInfo() {
    return baseService.get(this.controllerName + 'GetCurrentUserInfo');
  }

  getPermissionsByUser(userId) {
    return baseService.get(this.controllerName + 'GetPermissionsByUser/' + userId);
  }

}
export default new PersonService();